import {useI18n} from '@yandex-delivery/core/i18n'

import type {Paymethod} from '../types'

export function usePaymentTitle(method: Paymethod) {
  const i18n = useI18n()
  switch (method) {
    case 'already_paid':
      return i18n('ndd.payment.already_paid', 'Оплата не нужна')
    case 'card_on_receipt':
      return i18n('ndd.payment.card_on_receipt', 'Картой при получении')
    case 'cash_on_receipt':
      return i18n('ndd.payment.cash_on_receipt', 'Наличными при получении')
    case 'cashless':
      return i18n('ndd.payment.cashless', 'Безналичная оплата')
    case 'kassa_on_receipt':
    default:
      return ''
  }
}
